import { EditorSection } from '../EditorSection';
import { useCaps, usePlotEditorContext } from '../PlotEditorContext';
import { DataEncodingsControls } from '../data-encodings-controls';

/**
 * Data & Encodings Tab
 * Primary: Chart type, bar grouping, field mapping, orientation, category order
 * Advanced: Histogram options, filters, panel visibility
 */
export function DataEncodingsTab() {
  const caps = useCaps();
  const { plotlyJson, onUpdate } = usePlotEditorContext();

  return (
    <div className="space-y-4" data-lumi="encodings-panel">
      {/* Tab heading */}
      <div className="space-y-1">
        <h3 className="text-xs font-semibold text-foreground">Data & Encodings</h3>
        <p className="text-[11px] text-muted-foreground">
          Connect data columns to axes, series, and stacking.
        </p>
      </div>

      {/* Main chart / series controls */}
      <div className="space-y-2">
        <p className="text-[10px] font-semibold uppercase tracking-[0.08em] text-muted-foreground">
          Chart & Series
        </p>
        <DataEncodingsControls plotlyJson={plotlyJson} onUpdate={onUpdate} />
      </div>

      {/* Histogram & Special Plots section - only show if relevant */}
      {(caps.supports.histogramBinning || caps.special.hexbin || caps.special.volcano || caps.special.forest) && (
        <EditorSection
          id="histogram-special"
          title="Histogram & Special Plots"
          collapsible
          defaultCollapsed
        >
          <div className="space-y-3">
            {/* Histogram binning controls would go here */}
            {caps.special.volcano && (
              <div className="text-xs text-muted-foreground">
                Volcano plot controls (to be implemented)
              </div>
            )}
            {caps.special.forest && (
              <div className="text-xs text-muted-foreground">
                Forest plot controls (to be implemented)
              </div>
            )}
            {caps.special.hexbin && (
              <div className="text-xs text-muted-foreground">
                Hexbin controls (to be implemented)
              </div>
            )}
          </div>
        </EditorSection>
      )}
    </div>
  );
}

